import React, { useContext } from 'react';
import styled from 'styled-components';
import { PriceContext } from '../../../context/priceContext';
import utils from '../../../utils/utils';

const LocationSettingsAlert = () => {
  const [priceData] = useContext(PriceContext);
  const minOrderText = () => {
    let response;

    if (
      !priceData.minOrder ||
      Number(priceData.productTotal) > Number(priceData.minOrder)
    )
      response = null;
    if (Number(priceData.minOrder) > Number(priceData.productTotal)) {
      response = (
        <>
          <strong>
            Minimum rendelési összeg {utils.priceMask(priceData.minOrder)} Ft,
          </strong>{' '}
          <span style={{ fontSize: 'smaller' }}>
            ehhez hiányzik még{' '}
            {utils.priceMask(priceData.minOrder - priceData.productTotal)} Ft
          </span>
        </>
      );
    }

    return response;
  };

  const deliveryFeeText = () => {
    let response;

    if (!priceData.deliveryFee) {
      response = null;
    } else if (
      // 2020-12-10 pjung ERINT-943 Ha a felső határ NULL vagy 0, akkor számoljunk szállítási díjat...
      priceData.freeDeliveryLimit && Number(priceData.freeDeliveryLimit) <= Number(priceData.productTotal)
    ) {
      response = 'Ingyenes szállítás!';
    } else {
      response = `Szállítási költség ${utils.priceMask(priceData.deliveryFee)} Ft`;
    }

    return response;
  };

  const freeDeliveryLimitText = () => {
    let response;

    if (
      !priceData.freeDeliveryLimit ||
      Number(priceData.productTotal) >= Number(priceData.freeDeliveryLimit)
    ) {
      response = null;
    } else {
      response = `${utils.priceMask(
        priceData.freeDeliveryLimit
      )} Ft rendelés fölött ingyenes a szállítás`;
    }

    return response;
  };

  return (
    <Root>
      <span>{minOrderText()}</span>
      <span style={{ fontSize: 'larger' }}>
        <strong>{deliveryFeeText()}</strong>
      </span>
      <span style={{ fontSize: 'smaller' }}>{freeDeliveryLimitText()}</span>
    </Root>
  );
};

export default LocationSettingsAlert;

const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  height: 100%;
  padding-top: 16px;

  & * {
    width: 100%;
  }
`;
